module.exports = __webpack_public_path__ + "f4a753daf482c36bcc2f712f81d65680.png";